import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import { OrderCollectionModel, OrderModel } from "@insite/client-framework/Types/ApiModels";
import loadOrdersStatus from "@WhiteCap/Handlers/OrderHistory/LoadOrdersStatus";
import { getOrdersCustom } from "@WhiteCap/Services/GetOrderWithOrderId";
import { getOrderStatus } from "@WhiteCap/Store/Service/OrderDeliveryStatus";


type HandlerType = ApiHandler<GetOrdersApiParameter, OrderCollectionModel>;
export const RequestDataFromApiCustom: HandlerType = async props => {
    // props.apiResult = await getOrdersCustom(props.apiParameter);
    const OrderDataResult = await getOrdersCustom(props.apiParameter);
    if(OrderDataResult.orders){
        const orderStatusData = OrderDataResult.orders.map(order => order.properties.orderId);
                const orderNumbers: string[] = orderStatusData;
                if(orderStatusData.length > 0){
                    const OrderStatusResult = await getOrderStatus(orderNumbers);
                    if(OrderStatusResult.erpOrders){
                        OrderStatusResult.erpOrders.forEach(erpOrderB => {
                            let correspondingOrderA: OrderModel | undefined;
        
                            if (OrderDataResult.orders) {
                                correspondingOrderA = OrderDataResult.orders.find(
                                    orderA => orderA.properties.orderId === erpOrderB.oderId,
                                );
                            }
                            if (correspondingOrderA) {
                                correspondingOrderA.properties.shipViaDescription = erpOrderB.shipViaDescription;
                                correspondingOrderA.properties.trackingURLs = erpOrderB.trackingURLs.length > 0 ? erpOrderB.trackingURLs[0] : "";
                                correspondingOrderA.properties.orderLinesCount = erpOrderB.orderLinesCount.toString();
                                correspondingOrderA.properties.status = erpOrderB.status[0];
                                correspondingOrderA.properties.noOfShipmentPackages = erpOrderB?.noOfShipmentPackages?.toString();
                                correspondingOrderA.properties.isMultipleShipment = erpOrderB?.isMultipleShipment as unknown as string;
    
                                //  correspondingOrderA.properties = {
                                //     shipViaDescription: erpOrderB.shipViaDescription,
                                //     trackingURLs:erpOrderB.trackingURLs.length > 0 ? erpOrderB.trackingURLs[0] : "",
                                //     orderLinesCount: erpOrderB.orderLinesCount.toString(),
                                //     status: erpOrderB.status[0],
                                // };
                            }
                        });
                    }
                }
                
    }
    props.apiResult = OrderDataResult

    

};
replaceInChain(chain, RequestDataFromApi, RequestDataFromApiCustom);
